import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-certificate-detail-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './certificate-detail-modal.component.html',
  styleUrl: './certificate-detail-modal.component.less',
})
export class CertificateDetailModalComponent {
  @Input() record: any = null;
  @Output() closed = new EventEmitter<void>();

  getDaysRemaining(notAfter: string): number {
    return Math.ceil((new Date(notAfter).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  }

  getDaysClass(notAfter: string): string {
    const days = this.getDaysRemaining(notAfter);
    if (days < 0) return 'days-expired';
    if (days <= 30) return 'days-critical';
    if (days <= 90) return 'days-warning';
    return 'days-ok';
  }

  getRiskClass(riskLevel: string): string {
    switch (riskLevel?.toUpperCase()) {
      case 'CRITICAL': return 'risk-critical';
      case 'HIGH':     return 'risk-high';
      case 'MEDIUM':   return 'risk-medium';
      default:         return 'risk-low';
    }
  }

  getTlsClass(supported: boolean): string {
    return supported ? 'tls-supported' : 'tls-unsupported';
  }

  close(): void {
    this.closed.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.close();
  }
}
